var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xc_swiper"},[_c('div',{class:['swiper-container', `swiper-container_${_vm.uniqueId}`]},[_c('div',{staticClass:"swiper-wrapper"},[_vm._t("default")],2)]),_c('div',{class:['swiper-button-next', `next_${_vm.uniqueId}`]}),_c('div',{class:['swiper-button-prev', `prev_${_vm.uniqueId}`]})])
}
var staticRenderFns = []

export { render, staticRenderFns }